import { Routes } from '@angular/router';
import { AuthGuardAutoLogin } from '@nx-vigil/core/web/auth/feature';
import { conditionalInsert } from '@nx-vigil/core/web/shared/util';
import { IdentityShellComponent } from './identity-shell.component';

const defaultRoute = 'dashboard';

export function getRoutes(features: { [key: string]: boolean }): Routes {
  return [
    {
      path: '',
      canActivate: [AuthGuardAutoLogin],
      component: IdentityShellComponent,
      children: [
        ...conditionalInsert(
          features['dashboard'],
          {
            path: 'dashboard',
            title: $localize`:@@title-products:Products`,
            data: {
              icon: 'apps',
            },
            loadChildren: () =>
              import('@nx-vigil/identity/web/app-dashboard/feature').then(
                module => module.featureRoutes,
              ),
          },
          {
            path: '',
            redirectTo: defaultRoute,
            pathMatch: 'full',
          },
          {
            path: '**',
            redirectTo: defaultRoute,
            pathMatch: 'full',
          },
        ),
      ],
    },
  ];
}
